import { unref, computed } from 'vue'
import { PLATFORM } from '@/views/create/gdt/model/project-const.js'
import { useRoute } from 'vue-router/composables'

export const useGdtTemplateUtils = (planForm) => {
  const platform = computed(() => {
    return {
      isIOS: planForm.value.ch_platform_id === PLATFORM.IOS,
      isAndroid: planForm.value.ch_platform_id === PLATFORM.ANDROID,
      isMiniGame: planForm.value.ch_platform_id === PLATFORM.MINIGAME
    }
  })

  /**
 * @description: 判断是批量新建、复制、修改；单条修改流程
 * @return {Object}
 *  - isEdit: 是否编辑状态；新建流程从下一步返回到项目编辑时，会在url中添加t=edit
 *  - isDuplicate: 是否复制状态；任务批量复制
 *  - isModify: 是否修改状态；任务批量修改
 *  - isCreate: 是否新建状态；任务批量新建
 *  - isADA: 是否ADA
 *  - isV3: 是否V3
 */
  const pageStates = computed(() => {
    const route = useRoute()
    const { path } = route
    // 批量复制
    const isDuplicate = path.includes('/duplicate/')
    // 批量修改
    const isModify = path.includes('/edit/')
    // 单条修改
    const isUpdate = path.includes('/plan-edit')
    // 单条修改创意
    const isUpdateCreative = path.includes('/creative-edit')
    // 腾讯广告3.0模板新建计划
    const isTemplateCreate = path.includes('/gdt/template')
    return {
      isDuplicate,
      isModify,
      isUpdate,
      isUpdateCreative,
      isTemplateCreate
    }
  })

  return {
    platform,
    pageStates
  }
}
